import { FC } from 'react';
import { BodyText, Stack } from '@servicetitan/design-system';

/**
 * Placeholder rendered when a job-number search returns no matches.
 */
export const JobNumberNotFound: FC = () => {
  return (
    <Stack direction='column' className='m-t-3' alignItems='center'>
      <BodyText el='span' className='ta-center' bold subdued>
        No results found
      </BodyText>
      <BodyText el='span' subdued className='ta-center m-t--half' size='small'>
        Make sure you’re using the exact job booking number.
      </BodyText>
    </Stack>
  );
};
